import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toggleTour, setInfo, setCarousel } from "../actions/settingActions";

import { Link } from "react-router-dom";

import { withRouter } from "react-router-dom";

import DocumentTitle from "react-document-title";

import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Accordion from "@material-ui/core/Accordion";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Tooltip from "@material-ui/core/Tooltip";

import { ReactComponent as Close } from "../icons/close.svg";
import { ReactComponent as ArrowDown } from "../icons/arrow_down.svg";
import { ReactComponent as InfoIcon } from "../icons/info_blue_xs.svg";
import { ReactComponent as TravelExploreIcon } from "../icons/travel_explore_blue_xs.svg";
import { ReactComponent as FilterIcon } from "../icons/filter_alt_blue_xs.svg";
import { ReactComponent as DownloadIcon } from "../icons/cloud_download_xs.svg";

const styles = (theme) => ({
  tooltip: {
    backgroundColor: "white",
    color: "#00568E",
    fontSize: "9pt",
    border: "1px solid #00568E",
  },
});

const DialogTitle = (props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          style={{ position: "absolute", right: "8px", top: "5px" }}
          onClick={onClose}
        >
          <Close />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

const AccordionDetails = withStyles((theme) => ({
  root: {
    display: "block",
  },
}))(MuiAccordionDetails);

class Info extends Component {
  state = {
    title: "Informationen",
  };

  startTour = () => {
    this.props.history.push("/muehlenkataster");
    this.props.setInfo(false, "");
    this.props.toggleTour();
  };

  componentDidMount() {
    this.setState({ carousel: this.props.carousel }, () => {
      this.setInfo();
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.hash !== this.props.location.hash) {
      this.setInfo();
    }
  }

  setInfo = () => {
    if (this.props.location.hash === "#info") {
      this.props.setInfo(true, "");
      this.setState({ carousel: this.props.carousel, title: "Informationen" });
      this.props.setCarousel("info");
    } else if (this.props.location.hash === "#einleitung") {
      this.props.setInfo(true, "einleitung");
      this.setState({ carousel: this.props.carousel, title: "Einleitung" });
      this.props.setCarousel("info");
    } else if (this.props.location.hash === "#hilfestellungen") {
      this.props.setInfo(true, "hilfestellungen");
      this.setState({
        carousel: this.props.carousel,
        title: "Hilfestellungen",
      });
      this.props.setCarousel("info");
    } else if (this.props.location.hash === "#links") {
      this.props.setInfo(true, "links");
      this.setState({ carousel: this.props.carousel, title: "Links" });
      this.props.setCarousel("info");
    } else if (this.props.location.hash === "#impressum") {
      this.props.setInfo(true, "impressum");
      this.setState({ carousel: this.props.carousel, title: "Impressum" });
      this.props.setCarousel("info");
    } else if (this.props.location.hash === "#bibliotheken") {
      this.props.setInfo(true, "bibliotheken");
      this.setState({ carousel: this.props.carousel, title: "Bibliotheken" });
      this.props.setCarousel("info");
    } else {
      this.props.setInfo(false, "");
      this.props.setCarousel(this.state.carousel);
    }
  };

  render() {
    return (
      <div>
        <Tooltip
          title="Informationen zur Anwendung"
          classes={{
            tooltip: this.props.classes.tooltip,
          }}
        >
          <IconButton
            color="inherit"
            onClick={() => {
              this.props.history.push(
                this.props.location.pathname + "#einleitung"
              );
            }}
            className={"info-button"}
            style={{ padding: 0 }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="40"
              viewBox="0 0 24 24"
              width="40"
            >
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path
                d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                fill={this.props.color ? this.props.color : "white"}
              />
            </svg>
          </IconButton>
        </Tooltip>

        <Dialog
          onClose={() => {
            this.props.history.push(this.props.location.pathname);
          }}
          open={this.props.open && this.props.pdf === this.props.information}
          maxWidth={"md"}
          scroll={"body"}
          style={{ zIndex: 1303 }}
        >
          <DialogTitle
            onClose={() => {
              this.props.history.push(this.props.location.pathname);
            }}
            style={{ backgroundColor: "#00568E", color: "white" }}
            classes={this.props.classes}
          >
            Mühlenkataster
          </DialogTitle>
          <DialogContent style={{}}>
            <DocumentTitle
              title={`${this.state.title} | Mühlen im Kreis Herford`}
            >
              <div>
                <Accordion
                  style={{ margin: "10px 0" }}
                  expanded={this.props.panel === "einleitung"}
                  onChange={
                    this.props.panel === "einleitung"
                      ? () =>
                          this.props.history.push(
                            this.props.location.pathname + "#info"
                          )
                      : () =>
                          this.props.history.push(
                            this.props.location.pathname + "#einleitung"
                          )
                  }
                >
                  <AccordionSummary expandIcon={<ArrowDown />}>
                    {this.props.panel === "einleitung" ? (
                      <h4 style={{ fontWeight: "700" }}>Einleitung</h4>
                    ) : (
                      <h4 style={{ fontWeight: "400" }}>Einleitung</h4>
                    )}
                  </AccordionSummary>
                  <AccordionDetails>
                    <p>
                      Das Mühlenkataster des Kreises Herford geht auf eine
                      Forschungsarbeit zurück. Sie hat 1987 bis 1991
                      stattgefunden. Gesucht und dokumentiert wurden alle
                      Mühlenstandorte, die seinerzeit vorhandenen wie die schon
                      früher verschwundenen. In der Zwischenzeit sind weitere
                      Mühlen abgerissen worden. Mit mehr als 250 dokumentierten
                      Standorten weist der Kreis Herford eine sehr hohe
                      Mühlendichte auf. Das liegt an der Landschaft: Die vielen
                      kleinen Bäche haben häufig Gelegenheit geboten, mit
                      vergleichsweise geringem Aufwand Wassermühlen anzulegen.
                      Windmühlen waren zweite Wahl – sie hat man nur dort
                      gebaut, wo Wassermühlen den Bedarf nicht decken konnten.
                    </p>
                    <p>
                      Mühlen stammen aus einer Zeit, als von fossilen
                      Energieträgern noch keine Rede war. Als technische
                      Denkmäler sind sie wichtige Sachzeugen der regionalen
                      Geschichte.
                    </p>
                    <p>
                      Neben der Darstellung der einzelnen Mühlen gibt es{" "}
                      <Link to="/muehlenkataster/medien" className="appLink">
                        hier
                      </Link>{" "}
                      anschaulich Einblicke in das Innenleben einer Mühle.
                    </p>
                    <p>
                      Hat sich bei Ihnen um die Ecke vielleicht auch mal eine
                      Mühle befunden? Wir wünschen viel Freude beim Stöbern und
                      Entdecken – Klicken Sie sich um! <br />
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={this.startTour}
                        style={{ marginTop: "10px" }}
                      >
                        Tour starten
                      </Button>
                    </p>
                    <p>
                      Bei Rückfragen oder Anmerkungen zum Projekt freuen wir uns
                      über Ihre Nachricht: <br />
                      Christoph Mörstedt: Telefon,{" "}
                      <a href="tel:+5221131461" className={"appLink"}>
                        05221/13-1461
                      </a>
                      , E-Mail:{" "}
                      <a
                        href="mailto:c.moerstedt@kreis-herford.de"
                        className={"appLink"}
                      >
                        c.moerstedt@kreis-herford.de
                      </a>
                      .
                    </p>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  style={{ margin: "10px 0" }}
                  expanded={this.props.panel === "hilfestellungen"}
                  onChange={
                    this.props.panel === "hilfestellungen"
                      ? () =>
                          this.props.history.push(
                            this.props.location.pathname + "#info"
                          )
                      : () =>
                          this.props.history.push(
                            this.props.location.pathname + "#hilfestellungen"
                          )
                  }
                >
                  <AccordionSummary expandIcon={<ArrowDown />}>
                    {this.props.panel === "hilfestellungen" ? (
                      <h4 style={{ fontWeight: "700" }}>Hilfestellungen</h4>
                    ) : (
                      <h4 style={{ fontWeight: "400" }}>Hilfestellungen</h4>
                    )}
                  </AccordionSummary>
                  <AccordionDetails>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={this.startTour}
                    >
                      Tour starten
                    </Button>
                    <div
                      style={{
                        borderBottom: "1px solid rgba(0, 0, 0, 0.23)",
                        width: "100%",
                        marginTop: "20px",
                      }}
                    ></div>
                    <p>
                      <h4
                        style={{
                          marginBottom: "10px",
                          marginTop: "20px",
                          fontWeight: "600",
                        }}
                      >
                        Karussellinteraktion
                      </h4>
                      <img
                        alt="eigener Standort"
                        src={`${process.env.PUBLIC_URL}/carousel.png`}
                        width="100%"
                      />
                      Im obig dargestellten Karussell werden alle Mühlen im
                      aktuellen Kartenausschnitt bzw. entsprechend der
                      eingestellten Filter angezeigt. Die Mühlen lassen sich mit
                      den blauen Buttons rechts und links durchstöbern. Neben
                      einem Bild (wenn vorhanden) wird der jeweilige Name und
                      die Antriebsart der Mühle angegeben. Mit einem Klick auf
                      eine Mühle (bspw. auf das Bild oder den Namen) gelangt man
                      zu einer spezifischen Mühlen-Ansicht, die weiterführende
                      Informationen und Bilder über jene Mühle bereithält. Über
                      die Schaltfläche „in Karte anzeigen“ wird automatisch die
                      Karte aktualisiert und die ausgewählte Mühle im Zentrum
                      angezeigt. Die Mühle wird zudem im Karussell farblich
                      hervorgehoben.
                      <h4
                        style={{
                          marginBottom: "10px",
                          marginTop: "20px",
                          fontWeight: "600",
                        }}
                      >
                        Karteninteraktion
                      </h4>
                      <ul>
                        <li>
                          Bewegen: Klicken und Ziehen, Touch Gesten auf mobilen
                          Geräten
                        </li>
                        <li>
                          Zoomen: Mausrad, +/- Buttons, Touch Gesten auf mobilen
                          Geräten
                        </li>
                        <li>
                          <img
                            alt="eigener Standort"
                            src={`${process.env.PUBLIC_URL}/position.png`}
                          />
                          Eigener Standort (oben links)
                        </li>
                        <li>
                          <img
                            alt="Hintergrundkarte anzeigen"
                            src={`${process.env.PUBLIC_URL}/basemap.png`}
                          />
                          Hintergrundkarte ändern (unten links)
                        </li>
                        <li>
                          <img
                            alt="Hintergrundkarte anzeigen"
                            src={`${process.env.PUBLIC_URL}/zeitschieberegler.png`}
                          />
                          Zeitschieberegler (unten links): Es werden alle Mühlen
                          angezeigt, die zwischen 1200 und einem einstellbaren
                          Jahr erbaut worden sind. Dieser Vorgang kann über den
                          Play-Button automatisiert angestoßen werden, um sich
                          beispielsweise die Entwicklung des Mühlenbestandes im
                          Kreis Herford anzuschauen.(Alle angegebenen Filter
                          sind gleichzeitig wirksam.)
                        </li>
                        <li>
                          <img
                            alt="Legende anzeigen"
                            src={`${process.env.PUBLIC_URL}/legend.png`}
                          />
                          Legende anzeigen (oben rechts)
                        </li>
                        <li>
                          Informationen zur Mühle: Mit einem Klick auf ein
                          Mühlen-Icon in der Karte, wird die entsprechende Mühle
                          farbig hervorgehoben bzw. alle anderen Mühlen
                          ausgegraut. Zudem erscheint das zugehörige Mühlen-Bild
                          hervorgehoben im Karussell.
                        </li>
                      </ul>
                      <h4
                        style={{
                          marginBottom: "10px",
                          marginTop: "20px",
                          fontWeight: "600",
                        }}
                      >
                        Funktionen in der Toolbar
                      </h4>
                      <ul>
                        <li>
                          <FilterIcon /> Die Vielzahl an Mühlen im Kreisgebiet
                          können nach Gemeinde, Antriebsart und ob das Gebäude
                          vorhanden ist gefiltert werden. (Sämtliche
                          Kombinationen sind möglich und gleichzeitig wirksam.)
                        </li>
                        <li>
                          <TravelExploreIcon /> Verweis auf das Geschichtsportal
                          mit weiteren historischen Daten und Karten zum Kreis
                          Herford.
                        </li>
                        <li>
                          <DownloadIcon /> Es können die Informationen der
                          jeweiligen Mühle als PDF heruntergeladen werden. (Nur
                          in Informations-Ansicht der Mühle verfügbar.)
                        </li>
                        <li>
                          <InfoIcon /> Informationen und Hilfestellungen zu der
                          Anwendung.
                        </li>
                      </ul>
                    </p>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  style={{ margin: "10px 0" }}
                  expanded={this.props.panel === "links"}
                  onChange={
                    this.props.panel === "links"
                      ? () =>
                          this.props.history.push(
                            this.props.location.pathname + "#info"
                          )
                      : () =>
                          this.props.history.push(
                            this.props.location.pathname + "#links"
                          )
                  }
                >
                  <AccordionSummary expandIcon={<ArrowDown />}>
                    {this.props.panel === "links" ? (
                      <h4 style={{ fontWeight: "700" }}>Links</h4>
                    ) : (
                      <h4 style={{ fontWeight: "400" }}>Links</h4>
                    )}
                  </AccordionSummary>
                  <AccordionDetails>
                    <ul>
                      <li>
                        <Link
                          className={"appLink"}
                          to="/muehlenkataster/medien"
                        >
                          Mühlenkataster-Medien
                        </Link>
                        <br />
                      </li>
                      <li>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          className={"appLink"}
                          href="https://www.kreisheimatverein.de/"
                        >
                          Kreisheimatverein Herford e.V.
                        </a>
                        <br />
                      </li>
                      <li>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          className={"appLink"}
                          href="https://www.lwl.org/dlbw/denkmalpflege"
                        >
                          LWL Denkmalpflege
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          className={"appLink"}
                          href="https://www.deutsche-muehlen.de"
                        >
                          Deutsche Gesellschaft für Mühlenkunde und
                          Mühlenerhaltung e.V.
                        </a>
                      </li>
                    </ul>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  style={{ margin: "10px 0" }}
                  expanded={this.props.panel === "impressum"}
                  onChange={
                    this.props.panel === "impressum"
                      ? () =>
                          this.props.history.push(
                            this.props.location.pathname + "#info"
                          )
                      : () =>
                          this.props.history.push(
                            this.props.location.pathname + "#impressum"
                          )
                  }
                >
                  <AccordionSummary expandIcon={<ArrowDown />}>
                    {this.props.panel === "impressum" ? (
                      <h4 style={{ fontWeight: "700" }}>Impressum</h4>
                    ) : (
                      <h4 style={{ fontWeight: "400" }}>Impressum</h4>
                    )}
                  </AccordionSummary>
                  <AccordionDetails>
                    <h4 style={{ marginBottom: "10px", fontWeight: "600" }}>
                      Kontakt
                    </h4>
                    <p>
                      Kreis Herford
                      <br />
                      Amt für Kataster und Vermessung
                      <br />
                      Amtshausstr. 2<br />
                      32051 Herford
                      <br />
                      E-Mail:{" "}
                      <a
                        href="mailto:geoportal@kreis-herford.de"
                        className={"appLink"}
                      >
                        geoportal@kreis-herford.de
                      </a>
                      <br />
                      Telefon:{" "}
                      <a href="tel:+5221132628" className={"appLink"}>
                        05221/13-2628
                      </a>
                      <br />
                    </p>
                    <p>
                      Kreisheimatverein Herford e.V.
                      <br />
                      Amtshausstr. 3<br />
                      32051 Herford
                      <br />
                      E-Mail:{" "}
                      <a
                        href="mailto:anna.vogt@kreis-herford.de"
                        className={"appLink"}
                      >
                        anna.vogt@kreis-herford.de
                      </a>
                      <br />
                      Telefon:{" "}
                      <a href="tel:+5221132216" className={"appLink"}>
                        05221/13-2216
                      </a>
                      <br />
                    </p>

                    <h4
                      style={{
                        marginBottom: "10px",
                        marginTop: "20px",
                        fontWeight: "600",
                      }}
                    >
                      Anmerkung zum Digitalen Mühlenkataster
                    </h4>
                    <p style={{ textAlign: "justify" }}>
                      Es handelt sich um ein Gemeinschaftsprojektes des Kreises
                      Herford, des Katasteramtes des Kreises Herford und des
                      Kreisheimatvereins Herford e.V.
                      <br />
                      <p>
                        <Tooltip
                          placement="top"
                          title="Kreis Herford"
                          classes={{
                            tooltip: this.props.classes.tooltip,
                          }}
                        >
                          <a
                            href="https://www.kreis-herford.de/"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginRight: "10px" }}
                          >
                            <img
                              alt=""
                              src={
                                "https://geoportal.kreis-herford.de/images/kreisherford.svg"
                              }
                              height="55"
                            />
                          </a>
                        </Tooltip>
                        <Tooltip
                          placement="top"
                          title="Geoportal Kreis Herford"
                          classes={{
                            tooltip: this.props.classes.tooltip,
                          }}
                        >
                          <a
                            href="https://geoportal.kreis-herford.de/#geschichte"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginRight: "10px" }}
                          >
                            <img
                              alt=""
                              src={`${process.env.PUBLIC_URL}/logo_geoportal.svg`}
                              height="55"
                            />
                          </a>
                        </Tooltip>
                        <Tooltip
                          placement="top"
                          title="Kreisheimatverein Herford e.V."
                          classes={{
                            tooltip: this.props.classes.tooltip,
                          }}
                        >
                          <a
                            href="https://www.kreisheimatverein.de/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              alt=""
                              src={`${process.env.PUBLIC_URL}/kreis_heimatverein.png`}
                              height="55"
                            />
                          </a>
                        </Tooltip>
                      </p>
                      Die Inhalte des Digitalen Mühlenkatasters entstammen der
                      Publikation von Christoph Mörstedt: Mühlen im Kreis
                      Herford. Historisches Kataster, Bielefeld 1995
                      (mittlerweile vergriffen).
                    </p>

                    <h4
                      style={{
                        marginBottom: "10px",
                        marginTop: "20px",
                        fontWeight: "600",
                      }}
                    >
                      Bildnachweis
                    </h4>
                    <p style={{ textAlign: "justify" }}>
                      Die Fotografien{" "}
                      <a
                        className={"appLink"}
                        href={`${process.env.PUBLIC_URL}/copyright_LWL-DLBW.pdf`}
                      >
                        in der hier hinterlegten Liste
                      </a>{" "}
                      wurden von Frau Angelika Brockmann-Peschel von der
                      LWL-Denkmalpflege, Landschafts- und Baukultur in
                      Westfalen, zur Verfügung gestellt (© LWL-DLBW).
                      <br />
                      Alle weiteren Fotografien wurden durch Herrn Christoph
                      Mörstedt vom Kreis Herford angefertigt. Alle Daten,
                      insbesondere Texte und/oder Fotos, sind urheberrechtlich
                      geschützt. Jegliche Veröffentlichung von Texten und/oder
                      Fotos von unseren Internetseiten ist nur nach
                      schriftlicher Genehmigung durch den Kreisheimatverein
                      Herford e.V. oder den jeweiligen Rechteinhabern zulässig.
                      Eine ungenehmigte Nutzung z.B. von Texten und/oder Fotos
                      kann Schadensersatzansprüche zur Folge haben.
                    </p>

                    <h4
                      style={{
                        marginBottom: "10px",
                        marginTop: "20px",
                        fontWeight: "600",
                      }}
                    >
                      Audionachweis
                    </h4>
                    <p style={{ textAlign: "justify" }}>
                      Die Sound-Effekte wurden aus dem Sound-Archiv von
                      „Handwerk trifft Kultur“, einem Gemeinschaftsprojekt der
                      Kreise Herford und Minden-Lübbecke (
                      <a
                        href="www.handwerk-trifft-kultur.de"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="appLink"
                      >
                        www.handwerk-trifft-kultur.de
                      </a>
                      ) zur Verfügung gestellt. Alle Daten, insbesondere
                      Audio-Dateien, sind urheberrechtlich geschützt. Jegliche
                      Veröffentlichung von Audio-Dateien von unseren
                      Internetseiten ist nur nach schriftlicher Genehmigung
                      durch den Kreisheimatverein Herford e.V. oder den
                      jeweiligen Rechteinhabern zulässig. Eine ungenehmigte
                      Nutzung kann Schadensersatzansprüche zur Folge haben.
                    </p>

                    <h4
                      style={{
                        marginBottom: "10px",
                        marginTop: "20px",
                        fontWeight: "600",
                      }}
                    >
                      Videonachweis
                    </h4>
                    <p style={{ textAlign: "justify" }}>
                      Der Film „Der Mühlen-Bauhof des Mühlenvereins
                      Minden-Lübbecke“ wurde von Michael Trappmann in
                      Kooperation mit „Handwerk trifft Kultur“, einem
                      Gemeinschaftsprojekt der Kreise Herford und
                      Minden-Lübbecke (
                      <a
                        href="www.handwerk-trifft-kultur.de"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="appLink"
                      >
                        www.handwerk-trifft-kultur.de
                      </a>
                      ) zur Verfügung gestellt. Alle weiteren Videoaufnahmen
                      wurden durch Herrn Christoph Mörstedt vom Kreis Herford
                      angefertigt. Alle Daten, insbesondere Videos, sind
                      urheberrechtlich geschützt. Jegliche Veröffentlichung von
                      Videos von unseren Internetseiten ist nur nach
                      schriftlicher Genehmigung durch den Kreisheimatverein
                      Herford e.V. oder den jeweiligen Rechteinhabern zulässig.
                      Eine ungenehmigte Nutzung kann Schadensersatzansprüche zur
                      Folge haben.
                    </p>

                    <h4
                      style={{
                        marginBottom: "10px",
                        marginTop: "20px",
                        fontWeight: "600",
                      }}
                    >
                      Haftungshinweis
                    </h4>
                    <p style={{ textAlign: "justify" }}>
                      Die Inhalte des Geoportals im Kreis Herford stellt das Amt
                      für Kataster und Vermessung des Kreises Herford bereit.
                      Für die Inhalte sind die jeweilig zuständigen Ämter der
                      Kreisverwaltung sowie die kreisangehörigen Kommunen
                      verantwortlich. Es wird keine Gewähr für die Aktualität,
                      Richtigkeit, Vollständigkeit oder Qualität und
                      jederzeitige Verfügbarkeit der bereitgestellten
                      Informationen übernommen. Der Kreis Herford haftet nicht
                      für Schäden, die durch die Nutzung der bereitgestellten
                      Informationen entstehen. Für etwaige Schäden, die beim
                      Aufrufen oder Herunterladen von Daten durch Computerviren
                      oder der Installation oder Nutzung von Software verursacht
                      werden, wird nicht gehaftet. Der Kreis Herford behält es
                      sich ausdrücklich vor, einzelne Webseiten oder das gesamte
                      Angebot ohne gesonderte Ankündigung zu verändern, zu
                      ergänzen, zu löschen oder die Veröffentlichung zeitweise
                      oder endgültig einzustellen.
                    </p>

                    <h4
                      style={{
                        marginBottom: "10px",
                        marginTop: "20px",
                        fontWeight: "600",
                      }}
                    >
                      Links und Verweise
                    </h4>
                    <p style={{ textAlign: "justify" }}>
                      Trotz sorgfältiger inhaltlicher Kontrolle übernimmt der
                      Kreis Herford keine Haftung für die Inhalte externer
                      Links. Für den Inhalt der verlinkten Seiten sind
                      ausschließlich deren Betreiber verantwortlich.
                    </p>

                    <h4
                      style={{
                        marginBottom: "10px",
                        marginTop: "20px",
                        fontWeight: "600",
                      }}
                    >
                      Urheberrechtsschutz an Geodaten und Karten
                    </h4>
                    <p style={{ textAlign: "justify" }}>
                      Seit 01.01.2017 werden die digitalen Geobasisdaten nach
                      den Open Data Prinzipien kostenfrei bereitgestellt; sie
                      unterliegen den Nutzungsbedingungen.
                      <br />
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        className={"appLink"}
                        href="https://www.govdata.de/dl-de/by-2-0"
                      >
                        Datenlizenz Deutschland - Namensnennung - Version 2.0
                      </a>
                    </p>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  style={{ margin: "10px 0" }}
                  expanded={this.props.panel === "bibliotheken"}
                  onChange={
                    this.props.panel === "bibliotheken"
                      ? () =>
                          this.props.history.push(
                            this.props.location.pathname + "#info"
                          )
                      : () =>
                          this.props.history.push(
                            this.props.location.pathname + "#bibliotheken"
                          )
                  }
                >
                  <AccordionSummary expandIcon={<ArrowDown />}>
                    {this.props.panel === "bibliotheken" ? (
                      <h4 style={{ fontWeight: "700" }}>
                        verwendete Bibliotheken
                      </h4>
                    ) : (
                      <h4 style={{ fontWeight: "400" }}>
                        verwendete Bibliotheken
                      </h4>
                    )}
                  </AccordionSummary>
                  <AccordionDetails>
                    <ul>
                      <li>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          className={"appLink"}
                          href="https://developers.arcgis.com/"
                        >
                          ArcGis for Developers
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          className={"appLink"}
                          href="https://fonts.google.com/icons"
                        >
                          Icons - Google Fonts
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          className={"appLink"}
                          href="https://material-ui.com/"
                        >
                          Material-UI
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          className={"appLink"}
                          href="https://reactjs.org/"
                        >
                          React
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          className={"appLink"}
                          href="https://react-redux.js.org/"
                        >
                          React Redux
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          className={"appLink"}
                          href="https://reactour.js.org/"
                        >
                          Reactour
                        </a>
                      </li>
                    </ul>
                  </AccordionDetails>
                </Accordion>
              </div>
            </DocumentTitle>
          </DialogContent>
          <DialogActions
            style={{
              backgroundColor: "#00568E",
              color: "white",
              justifyContent: "start",
              padding: "16px 24px",
            }}
          >
            &copy; {new Date().getFullYear()} Kreis Herford - Kataster und
            Vermessung
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

Info.propTypes = {
  toggleTour: PropTypes.func.isRequired,
  setInfo: PropTypes.func.isRequired,
  panel: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  setCarousel: PropTypes.func.isRequired,
  carousel: PropTypes.string.isRequired,
  selected: PropTypes.object.isRequired,
  pdf: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  panel: state.settings.info.panel,
  open: state.settings.info.open,
  carousel: state.settings.carousel,
  selected: state.mill.selected,
  pdf: state.mill.pdf,
});

export default connect(mapStateToProps, {
  toggleTour,
  setInfo,
  setCarousel,
})(withRouter(withStyles(styles, { withTheme: true })(Info)));
